import { render, staticRenderFns } from "./ApprenticeList.vue?vue&type=template&id=9c1b190a&scoped=true&"
import script from "./ApprenticeList.vue?vue&type=script&lang=js&"
export * from "./ApprenticeList.vue?vue&type=script&lang=js&"
import style0 from "./ApprenticeList.vue?vue&type=style&index=0&id=9c1b190a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1b190a",
  null
  
)

export default component.exports